import {
  SET_URL_DATA,
  FETCH_LANGUAGES,
  SET_SIDEBAR_STATUS,
  SET_BREADCRUMB,
  FETCH_CATEGORIES,
  FETCH_NOTES,
  SET_ROUTE,
  FETCH_PERMISSIONS,
} from '../actions/globalAction';
import { FETCH_FALLBACK_LANGUAGES } from '../actions/moduleAction';

const initialState = {
  urlData: null,
  languages: null,
  fallbackLanguages: null,
  isSidebar: false,
  route: null,
  permissions: [],
};
const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_URL_DATA: {
      return {
        ...state,
        urlData: action.payload,
      };
    }
    case SET_BREADCRUMB: {
      return {
        ...state,
        breadcrumb: action.payload,
      };
    }
    case FETCH_LANGUAGES: {
      return {
        ...state,
        languages: action.payload,
      };
    }
    case FETCH_FALLBACK_LANGUAGES: {
      return {
        ...state,
        fallbackLanguages: action.payload,
      };
    }
    case SET_SIDEBAR_STATUS: {
      return {
        ...state,
        isSidebar: action.payload,
      };
    }
    case FETCH_CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case FETCH_NOTES: {
      return {
        ...state,
        notes: action.payload,
      };
    }
    case SET_ROUTE: {
      return {
        ...state,
        route: action.payload,
      };
    }
    case FETCH_PERMISSIONS: {
      return {
        ...state,
        permissions: action.payload,
      };
    }
    default:
      return state;
  }
};
export default globalReducer;
